/* perf 30.09 D-10: skrypt sekcji „Specyfikacja produktu” przeniesiony z inline sections/dane-techniczne-produktu.liquid
   (5 KB HTML na każdej karcie, osobna funkcja toggleSpecs_<id sekcji> dla każdej instancji) do pliku z defer.
   Logika bez zmian (z poprawką A-01); nagłówek rozwija tabelę przez [data-sv-specs-toggle] zamiast onclick.
   Dane sekcji z atrybutów <section data-sv-specs data-section-id data-variant-mappings>; każda sekcja startuje raz.
   P5 10.10: nowy znacznik = <details class="sv-karta" id="specs-content-<id>"> (otwiera assets/sv-rozwijane.js), więc tu
   przełączanie działa tylko dla starego div [data-sv-specs-toggle]; brak elementu albo strzałki nie rzuca błędem. */
(function () {
  // perf 30.09 (R2-04): wspólny rejestr dla wszystkich wykonań pliku - dwie instancje sekcji = dwa <script src>, każdy korzeń startuje raz
  const started = window.__svSpecsStarted || (window.__svSpecsStarted = new WeakSet());

  function toggleSpecs(sectionId) {
    const content = document.getElementById('specs-content-' + sectionId);
    const arrow = document.getElementById('specs-arrow-' + sectionId);
    if (!content || content.tagName === 'DETAILS') return; // P5 10.10: karta <details> przełącza się sama

    content.classList.toggle('expanded');
    if (arrow) arrow.classList.toggle('specs-arrow-rotated');
  }

  function initSpecs(root) {
    if (started.has(root)) return;
    started.add(root);
    const sectionId = root.getAttribute('data-section-id');
    const header = root.querySelector('[data-sv-specs-toggle]');
    if (header) header.addEventListener('click', function () { toggleSpecs(sectionId); });

    // perf 30.09 C-24: animacja iskierek przycisku instrukcji stoi, gdy przycisku nie ma na ekranie (CSS w sekcji)
    const pdfButton = root.querySelector('.custom-generate-button');
    if (pdfButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        pdfButton.classList.toggle('sv-anim-off', !entries[entries.length - 1].isIntersecting);
      }).observe(pdfButton);
    }

    const section = document.getElementById('shopify-section-' + sectionId) || root;
    
    // Pobieranie mapowania wariantów
    const variantMappings = root.getAttribute('data-variant-mappings') || '';
    let mappingsArray = [];
    try {
      mappingsArray = JSON.parse(variantMappings);
    } catch (e) {
      mappingsArray = ["Czarny", "Biały", "Srebrny"];
    }
    
    const content = document.getElementById('specs-content-' + sectionId);
    const arrow = document.getElementById('specs-arrow-' + sectionId);

    // P5 10.10: tylko stary znacznik; karty <details> startują zamknięte z HTML, a zakładka Dane mogła je już otworzyć
    if (content && content.tagName !== 'DETAILS') {
      content.classList.remove('expanded');
      if (arrow) arrow.classList.remove('specs-arrow-rotated');
    }
    
    // Funkcja do aktualizacji wartości na podstawie wybranego wariantu
    function updateVariantValues(selectedValue) {
      if (!section) return;
      
      // Znajdujemy indeks wariantu
      let variantIndex = 1;
      const normalizedValue = selectedValue.toLowerCase().trim();
      
      for (let i = 0; i < mappingsArray.length; i++) {
        if (mappingsArray[i].toLowerCase() === normalizedValue) {
          variantIndex = i + 1;
          break;
        }
      }
      
      const variantValues = section.querySelectorAll('.variant-dependent-value');
      
      variantValues.forEach(value => {
        const newValue = value.getAttribute('data-variant-' + variantIndex);
        if (newValue) {
          value.textContent = newValue;
        }
      });
    }
  
    // Znajdowanie inputów wariantów
    function findVariantInputs() {
      // Szukamy inputów radio dla wariantów
      /* SkinVibe 26.09: radia tylko z wyboru wariantu karty - koszyk (karty bestsellerow) ma wlasne zaznaczone radia xs-color, ktore wczesniej byly czytane jako kolor produktu */
      let inputs = (document.querySelector('variant-selects, variant-radios') || document).querySelectorAll('input[type="radio"]');
      
      // Filtrujemy tylko te, które dotyczą kolorów
      let colorInputs = [];
      inputs.forEach(input => {
        if (input.name && (
            input.name.toLowerCase().includes('color') ||
            input.name.toLowerCase().includes('kolor') ||
            input.name.includes('option1') ||
            input.name.includes('option-0') ||
            input.closest('fieldset')?.querySelector('legend')?.textContent.toLowerCase().includes('olor')
        )) {
          colorInputs.push(input);
        }
      });
      
      return colorInputs.length > 0 ? colorInputs : inputs;
    }
  
    // Nasłuchiwanie na zmiany w inputach wariantów
    if (mappingsArray.length > 0) {
      /* perf 30.09 A-01: nasluch delegowany na stalym <product-info>. variant-selects jest podmieniany po kazdej
         zmianie wariantu (product-info.js -> HTMLUpdateUtility.viewTransition), wiec nasluch przypiety do radia dzialal tylko
         przy pierwszej zmianie koloru (lab 30.09: po 2. i 3. zmianie tabela pokazywala dalej model/EAN poprzedniego koloru). */
      const trackedNames = new Set(Array.from(findVariantInputs()).map(input => input.name));
      const variantRoot = document.querySelector('product-info[id^="MainProduct-"]') || document;

      variantRoot.addEventListener('change', function(event) {
        const input = event.target;
        if (!input || !input.closest || !input.closest('variant-selects, variant-radios')) return;
        if (input.type === 'radio' && !trackedNames.has(input.name)) return;
        updateVariantValues(input.value);
      });
      
      // Event Shopify
      document.addEventListener('variant:change', function(event) {
        /* SkinVibe 26.09: JSON wariantu nie ma pola product - ta sciezka to tylko zapas; zdjecia i dane zmienia nasluch 'change' */
        if (event.detail && event.detail.variant && event.detail.variant.product) {
          const colorOption = event.detail.variant.options.find((option, index) => {
            const optionName = event.detail.variant.product.options[index];
            return optionName && (
              optionName.toLowerCase().includes('color') ||
              optionName.toLowerCase().includes('kolor')
            );
          });
          
          if (colorOption) {
            updateVariantValues(colorOption);
          }
        }
      });
    
      // Inicjalizacja przy załadowaniu strony
      setTimeout(() => {
        const checkedInput = (document.querySelector('variant-selects, variant-radios') || document).querySelector('input[type="radio"]:checked');
        const selectedOption = document.querySelector('select option:checked');
        
        if (checkedInput) {
          const selectedValue = checkedInput.value;
          updateVariantValues(selectedValue);
        } else if (selectedOption) {
          const selectedValue = selectedOption.value;
          updateVariantValues(selectedValue);
        }
      }, 100);
    }
  }

  function init() {
    document.querySelectorAll('[data-sv-specs]').forEach(initSpecs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
